export const UNKNOWN_ERROR_TRANSLATION_KEY: string = 'error.unknown.server.error';
